export function beforeRegistration({ Vue, config, store, isServer }) { }
